import React, { useCallback, useEffect, useRef, useState } from "react";
import MultiSelect from "./multi-select";

const AsyncMultiSelect = (props) => {
    const {
        loadOptions: loadOptionsProp,
        minSearchLength = 2,
        defaultLoadOptions = false,
        wrapValues,
        ...rest
    } = props;

    const [options, setOptions] = useState([]);
    const [selectInput, setSelectInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const debounceRef = useRef(null);
    const latestInputRef = useRef("");

    const loadOptions = useCallback((inputValue = "", force = false) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        const trimmedInput = inputValue.trim();

        if (!force && trimmedInput.length < minSearchLength) {
            setOptions([]);
            return;
        }

        latestInputRef.current = inputValue;

        debounceRef.current = setTimeout(async () => {
            try {
                setIsLoading(true);

                await loadOptionsProp(inputValue, (data) => {
                    if (latestInputRef.current === inputValue) {
                        setOptions(data);
                    }
                });
            } catch (error) {
                if (latestInputRef.current === inputValue) {
                    setOptions([]);
                }
            } finally {
                if (latestInputRef.current === inputValue) {
                    setIsLoading(false);
                }
            }
        }, 500);
    }, [loadOptionsProp, minSearchLength]);

    useEffect(() => {
        if (defaultLoadOptions) {
            loadOptions("", true);
        }

        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, [defaultLoadOptions, loadOptions]);

    const onInputChange = (inputValue, { action }) => {
        if (action === "input-blur" || action === "set-value") return;

        if (action === "menu-close" && selectInput !== "") {
            setSelectInput("");
            setOptions([]);
            return;
        }

        setSelectInput(inputValue);
        loadOptions(inputValue);
    };

    return (
        <MultiSelect
            {...rest}
            inputValue={selectInput}
            onInputChange={onInputChange}
            options={options}
            wrapValues={wrapValues}
            isLoading={isLoading}
            noOptionsMessage={() =>
                selectInput.trim().length < minSearchLength
                    ? `Digite pelo menos ${minSearchLength} caracteres`
                    : "Nenhum item encontrado"
            }
        />
    );
};

export default AsyncMultiSelect;